import { RouteObject, Navigate } from "react-router-dom";
import MainRoot from "../components/root/MainRoot";
import { getCookie } from "../utils/cookies";
import Dashboard from "../pages/dashboard/Dashboard";
import Login from "../pages/auth/login/Login";
import NotFound from "../pages/not-found/NotFound";
import Products from "../pages/products/Products";
import Info from "../pages/info/Info";
import Orders from "../pages/orders/Orders";
import Messages from "../pages/messages/Messages";
import Delivery from "../pages/delivery/Delivery";
import Settings from "../pages/settings/Settings";
import AuthRoot from "../components/root/AuthRoot";
import Otp from "../pages/auth/otp/Otp";
import Register from "../pages/auth/register/Register";
import ForgetPassword from "../pages/auth/forget-password/ForgetPassword";
import ConfrimPassword from "../pages/auth/confrim-password/ConfrimPassword";
import CreateProduct from "../pages/products/create/CreateProduct";
import Notifications from "../pages/notifications/Notifications";
import EditProducts from "../pages/products/edit/EditProducts";
import CreateVariant from "../pages/products/create/CreateVariants";
import CreateVariantImages from "../pages/products/create/CreateVariantImages";
import EditVariants from "../pages/products/edit/EditVariants";
import EditVariantImages from "../pages/products/edit/EditVariantImages";
import LowStockProducts from "../pages/products/LowStockProducts";

const access_token = getCookie("StoreDashboardAccessToken");

const ROUTES: RouteObject[] = [
  {
    path: "/",
    element: (
      <Navigate to={`${access_token ? "/dashboard" : "/auth"}`} replace />
    ),
  },
  {
    path: "/dashboard",
    element: <MainRoot />,
    children: [
      {
        path: "/dashboard/",
        element: <Dashboard />,
      },
      {
        path: "products",
        element: <Products />,
      },
      {
        path: "products/create",
        element: <CreateProduct />,
      },
      {
        path: "products/low-stock",
        element: <LowStockProducts />,
      },
      {
        path: "products/create-variants/:id",
        element: <CreateVariant />,
      },
      {
        path: "products/create-variant-images/:id",
        element: <CreateVariantImages />,
      },
      {
        path: "products/edit/:id",
        element: <EditProducts />,
      },
      {
        path: "products/edit-variants/:id",
        element: <EditVariants />,
      },
      {
        path: "products/edit-variant-images/:id",
        element: <EditVariantImages />,
      },
      {
        path: "info",
        element: <Info />,
      },
      {
        path: "orders",
        element: <Orders />,
      },
      {
        path: "messages",
        element: <Messages />,
      },
      {
        path: "delivery",
        element: <Delivery />,
      },
      {
        path: "settings",
        element: <Settings />,
      },
      {
        path: "notifications",
        element: <Notifications />,
      },
    ],
  },
  {
    path: "/auth",
    element: <AuthRoot />,
    children: [
      {
        index: true,
        element: <Navigate to="login" replace />,
      },
      {
        path: "/auth/login",
        element: <Login />,
      },
      {
        path: "/auth/otp",
        element: <Otp />,
      },
      {
        path: "/auth/register",
        element: <Register />,
      },
      {
        path: "/auth/forget-password",
        element: <ForgetPassword />,
      },
      {
        path: "/auth/confrim-forget-password",
        element: <ConfrimPassword />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default ROUTES;
